/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerplacementtopright3Inputs */

const en_flyerplacementtopright3 = /** @type {(inputs: Flyerplacementtopright3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top right`)
};

const de_flyerplacementtopright3 = /** @type {(inputs: Flyerplacementtopright3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben rechts`)
};

/**
* | output |
* | --- |
* | "Top right" |
*
* @param {Flyerplacementtopright3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerplacementtopright3 = /** @type {((inputs?: Flyerplacementtopright3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerplacementtopright3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerplacementtopright3(inputs)
	return de_flyerplacementtopright3(inputs)
});
export { flyerplacementtopright3 as "flyerPlacementTopRight" }